import Cargos from '@/models/Cargos'

export default [
  {
    path: '/administrativo/financas',
    name: 'rota-financas',
    autenticado: true,
    cargo: [Cargos.ADMINISTRADOR],
    titulo: 'Finanças',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Finanças',
      icon: 'piggy-bank',
    },
    component: () => import(/* webpackChunkName: "financas" */ '../views/financas/Financas.vue'),
  },
]
